export default __webpack_public_path__ + "static/media/entertainment1.9622b64a.jpg";